"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var webAApi_1 = require("../../../../api/webAApi");
var SupportPlayerDetailListCtl = /** @class */ (function (_super) {
    __extends(SupportPlayerDetailListCtl, _super);
    function SupportPlayerDetailListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key_uid = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key_uid; });
        _this.dk_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_login; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_player_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_email; });
        _this.dk_player_currency_iso = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_currency_iso; });
        _this.dk_is_verifed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_verifed; });
        _this.dk_date_added_uts_ms = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added_uts_ms; });
        _this._errDialog = errDialog;
        return _this;
    }
    SupportPlayerDetailListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total_count: 0,
        };
    };
    SupportPlayerDetailListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListAvailPlayerListByPlayerEmailPart.exec({
            brand_id_list: data.brands_id_list,
            all_brands: data.all_brands,
            partial_email: data.partial_email
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total_count = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key_uid: resp.list[i].key_uid,
                    player_login: resp.list[i].player_login,
                    brand_title: resp.list[i].brand_title,
                    player_email: resp.list[i].player_email,
                    player_currency_iso: resp.list[i].player_currency_iso,
                    is_verifed: resp.list[i].is_verifed,
                    date_added_uts_ms: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return SupportPlayerDetailListCtl;
}(BaseController_1.BaseController));
exports.SupportPlayerDetailListCtl = SupportPlayerDetailListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/support_player_detail/ctl/SupportPlayerDetailListCtl.ts
// module id = 1030
// module chunks = 0